import "./SignUp.scss";
import React, { useState, useContext } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword, updateProfile } from "firebase/auth";
import { auth } from "../../../firebase";
import { AuthContext } from "../../../context/AuthContext";

function SignUp() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loginUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      //  Create the Firebase user
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      );

      const firebaseUser = userCredential.user;

      //  Update displayName in Firebase
      await updateProfile(firebaseUser, { displayName: name });

      //  Store user info in context
      // loginUser({
      //   uid: firebaseUser.uid,
      //   email: firebaseUser.email,
      //   displayName: firebaseUser.displayName || name,
      // });

      alert("Signup successful! 🎉");
      navigate("/stories");
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };

  return (
    <div className="d-flex vh-100 justify-content-center align-items-center bg-secondary">
      <div className="signup p-3 bg-white  rounded">
        <h2 className="signup__title">UnGriefMe</h2>
        <h3 className="signup__sub-title">Sign Up!</h3>
        <form className="signup__form" onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Name"
            className="signup__name  form-control mb-3"
            onChange={(e) => setName(e.target.value)}
            required
          />
          <input
            type="email"
            placeholder="Email"
            className="signup__email form-control mb-3"
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <input
            type="password"
            placeholder="Password"
            className="signup__passwd mb-3"
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <button className="btn btn-success w-100">Sign Up!</button>
        </form>

        <p className="signup__back-to-login mt-3">Already have an account?</p>
        <Link to="/login" className="signup__login-link">
          Login
        </Link>
      </div>
    </div>
  );
}

export default SignUp;
